export type ResumeDecisionInput = {
  hasAuthData: boolean;
  authExpired: boolean;
  secureCredentialValid: boolean;
  secureCredentialExpired: boolean;
  biometricsLoggedIn: boolean;
};

export type ResumeDecision =
  | "runBiometricReauth"
  | "logoutExpiredNoRecovery"
  | "refreshToken"
  | "noop";

/**
 * Deterministic resume decision tree.
 * Always prefer biometric recovery when we have a valid secure credential and
 * auth is missing/expired or biometrics has not been restored in redux yet.
 */
export const decideResumeAction = ({
  hasAuthData,
  authExpired,
  secureCredentialValid,
  secureCredentialExpired,
  biometricsLoggedIn,
}: ResumeDecisionInput): ResumeDecision => {
  if (
    secureCredentialValid &&
    !secureCredentialExpired &&
    (authExpired || !hasAuthData || !biometricsLoggedIn)
  ) {
    return "runBiometricReauth";
  }

  if (authExpired || secureCredentialExpired) {
    return "logoutExpiredNoRecovery";
  }

  if (hasAuthData) {
    return "refreshToken";
  }

  return "noop";
};

export type ExpiryGuardInput = {
  isInForeground: boolean;
  biometricsInProgress: boolean;
  biometricsOptInPage: string | boolean | null;
  resumeAuthLock: boolean;
};

export const shouldBlockExpiryHandlers = ({
  isInForeground,
  biometricsInProgress,
  biometricsOptInPage,
  resumeAuthLock,
}: ExpiryGuardInput): boolean => {
  if (!isInForeground) return true;
  return Boolean(biometricsInProgress || biometricsOptInPage || resumeAuthLock);
};
